import validateRules from "@/helpers/validate_rules";

export const initialForm = {
    name: "",
    password: "",
};

export const inputs = [
    {
        label: "Ваш логин",
        key: "name",
        rules: validateRules.authLogin,
        placeholder: "Ваш логин",
        type: "text",
        name: 'username'
    },
    {
        label: "Пароль",
        key: "password",
        rules: validateRules.authPassword,
        placeholder: "Ваш пароль",
        type: "password",
        name: 'password'
    },
];
